export const SET_LOCATION = 'SET_LOCATION';
export const RESET_lOCATION = 'RESET_lOCATION';